// Snapshot files
const TheSnapshotMain = () => import('../views/TheSnapshotMain')
const SnapshotTable = () => import('../views/SnapshotTable')
const AppList = () => import('../views/AppList')
const TheSnapshotImagelist = () => import('../views/TheSnapshotImageList')
const TheSnapshotFileDiff = () => import('../views/TheSnapshotFileDiff')
const SnapshotDistribute = () => import('../views/SnapshotDistribute')
const InstanceOverview = () => import('../views/InstanceOverview.vue')
const Steppers = () => import('@/components/Steppers')
const TheSnapshotAddAppFinalHint = () => import('../views/TheSnapshotAddAppFinalHint')
const TheSnapshotDistributions = () => import('../views/TheSnapshotDistributions')
const SnapshotAssignments = () => import('../views/SnapshotAssignments')
const Assignment = () => import('../views/Assignment')
const VimeoVideos = () => import('../views/VimeoVideos')
const AppStore = () => import('../views/AppStore')
const AppScale = () => import('../views/AppScale')
const AppSessions = () => import('../views/AppSessions')
const SessionLogs = () => import('../views/SessionLogs')

// Space files
const InstanceList = () => import('@/modules/space/components/InstanceList.vue')
// Instance files
const SnapshotList = () => import('@/modules/instance/views/SnapshotList')
const InstanceConfiguration = () => import('@/modules/instance/views/InstanceConfiguration.vue')

export default [
    {
        path: '/org/:oid/space/:sid/instance/:iid/snapshot/:snid',
        name: 'snapshot-main',
        components: {
            default: TheSnapshotMain
        },
        children: [
            {
                path: 'overview',
                name: 'snapshot-overview',
                components: {
                    default: InstanceOverview
                }
            },
            {
                path: 'tables',
                name: 'snapshot-tables',
                components: {
                    default: SnapshotTable
                }
            },
            {
                path: `files/:fileArea/:localPath*`,
                name: 'snapshot-files'
            },
            {
                path: `files`,
                redirect: `files/files`
            },
            {
                path: 'file-diff/:fid',
                name: 'snapshot-file-diff',
                components: {
                    default: TheSnapshotFileDiff
                }
            },
            {
                path: 'applications',
                name: 'snapshot-applications',
                components: {
                    default: AppList
                }
            },
            {
                path: 'images',
                name: 'snapshot-images',
                components: {
                    default: TheSnapshotImagelist
                }
            },
            {
                path: 'distributions',
                name: 'snapshot-distributions',
                components: {
                    default: TheSnapshotDistributions
                }
            },
            {
                path: 'assignments',
                name: 'snapshot-assignments',
                components: {
                    default: SnapshotAssignments
                }
            },
            {
                path: 'assignment/:bid',
                name: 'assignment',
                components: {
                    default: Assignment
                },
                children: [
                    {
                        path: `handin/:hid/files/:localPath*`,
                        name: 'handin'
                    },
                    {
                        path: `handback/:hid/files/:localPath*`,
                        name: 'handback'
                    }
                ]
            },
            {
                path: 'vimeo-videos',
                name: 'vimeo-videos',
                component: VimeoVideos
            },
            {
                path: 'application/:aid/scale',
                name: 'application-scale',
                component: AppScale
            },
            {
                path: 'applications/add',
                name: 'snapshot-applications-add',
                components: {
                    default: AppStore,
                    notifications: Steppers
                }
            },
            {
                path: 'applications/appstore',
                name: 'appstore',
                components: {
                    default: AppStore
                }
            },
            {
                path: 'distribute',
                name: 'snapshot-distribute',
                components: {
                    default: SnapshotDistribute
                }
            },
            {
                path: 'addFiles',
                name: 'snapshot-add-files-hint',
                components: {
                    default: TheSnapshotAddAppFinalHint,
                    notifications: Steppers
                }
            },
            {
                path: 'instances',
                name: 'space-instances',
                components: {
                    default: InstanceList
                }
            },
            {
                path: 'instance-configuration/:tab?',
                name: 'instance-configuration',
                components: {
                    default: InstanceConfiguration
                }
            },
            {
                path: 'snapshots',
                name: 'instance-snapshots',
                components: {
                    default: SnapshotList
                }
            },
            {
                path: 'application/:aid/sessions',
                name: 'app-sessions',
                components: {
                    default: AppSessions
                }
            },
            {
                path: 'application/:aid/session/:sessId/logs',
                name: 'session-logs',
                component: SessionLogs
            },
            {
                path: 'application/:aid/:sessionId?',
                name: 'app-open'
            }
        ]
    }
]
